// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iKYV","newExpiryDate":"styles_newExpiryDate__3Pw6-","footer":"styles_footer__2OpmG"};